module.exports = __webpack_public_path__ + "static/img/301.5a7f374.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/news/301.png
// module id = bZO/
// module chunks = 0